import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { SUPPORT_EMAIL } from '@/features/support/support-service'

export function NoItemsView() {
  const { t } = useTranslation()

  const handleCopyEmail = () => {
    navigator.clipboard.writeText(SUPPORT_EMAIL)
    toast.success(t('support_mail_copied_message'))
  }

  return (
    <div className="flex flex-col items-center px-[24px] pt-[64px]">
      <img src="/images/no-plan.webp" alt="" className="size-[260px]" />

      <div className="flex flex-col items-center gap-[16px] text-center">
        <h2 className="font-display text-[36px] font-medium leading-[44px] text-app-grey-900">
          {t('unavaliable_discovery_title')}
        </h2>
        <p className="max-w-[345px] font-sans text-[18px] leading-[22px] tracking-[-0.36px] text-app-grey-900">
          {t('unavaliable_discovery_subtitle')}{' '}
          <button
            type="button"
            onClick={handleCopyEmail}
            className="cursor-pointer font-medium text-app-primary-600 underline"
          >
            {SUPPORT_EMAIL}
          </button>
        </p>
      </div>
    </div>
  )
}
